import parseFAQs from '@firsttable/functions/dist/parseFAQs';
import { FAQ } from '@firsttable/web-components/molecules';
import React from 'react';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import parseHtml from '../../../lib/parseHtml';

/**
 * @file FAQs.tsx
 * Component for FAQs.
 * This component is used in SideMenuLayout
 */
const FAQs = ({ page }: { page: any }) => {
  const faqs = parseFAQs(page);
  return (
    <TrackProvider
      pageEventName="account_viewed"
      source_page="faqs"
      source_page_section={page.id === 6725 ? 'frequent foodies' : null}>
      {faqs.map(({ question, answer }, i: number) => (
        <FAQ key={i} body={parseHtml(answer)} title={question} />
      ))}
    </TrackProvider>
  );
};

export default FAQs;
